import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";

export const EditIncomeWithdrawalsSteppersMap = {
    incomePaymentDetails: "Income payment details",
    review: "Review",
    confirm: "Confirmation",
};

export const productMap = {
    [SubAccountType.Sipp]: "SIPP",
    [SubAccountType.StocksIsa]: "ISA Stocks & Shares",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.WrapCash]: "Wrap Cash",
};


export const editIncomePaymentDetailsLabels = {
        targetSpecificArrangements: "Do you wish to target specific arrangements?",
        takeDifferentInitialIncomePayment: "Do you wish to take a different initial income payment?",
        grossInitialIncomePayment: "Gross initial income payment",
        maximumInitialIncomePayment: "Maximum for initial income payment",
        maximumIncomePerPayment: "Maximum income per payment",
        grossIncomePerPayment: "Gross income per payment",
        grossIncomePerPaymentFromPension: "Gross income per payment from the pension",
        incomeFrequency: "Income frequency",
        firstPaymentDate: "First payment date"
};